module.exports = __webpack_public_path__ + "bdd0e1f30d1632a6cecd802ce24c68ab.svg";